import { Component, Input } from '@angular/core';
import { RoutesPath } from '../../../../shared/constants/routes-path';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { ApiEndPoints, ApiRoot } from '../../../../shared/constants/api-endpoints';
import { Utils } from '../../../../Utils/utils';
import { ApiService } from '../../../../core/services/api.service';
import { SharedService } from '../../../../shared/services/shared.service';
import { SkeletonLoaderComponent } from "../../../../shared/components/skeleton-loader/skeleton-loader.component";
import { PaymentStatementRequest } from '../../payments/models/payment-request.model';

@Component({
  selector: 'app-payment-confirmation',
  imports: [CommonModule, TranslateModule, ButtonComponent, SkeletonLoaderComponent, RouterLink],
  templateUrl: './payment-confirmation.component.html',
  styleUrl: './payment-confirmation.component.scss'
})
export class PaymentConfirmationComponent {
  @Input() referenceNumber = '';
  @Input() companyName = '';
  @Input() membershipNumber = '';
  isStandalone:boolean = false;
  request: PaymentStatementRequest = new PaymentStatementRequest();

  type!: string;
  token!: string;
  spTrn!: string;
  srNumber!: string;
  venueBookingId: string = '';
  private venuePaymentStatusUpdated = false;
  batchData: any;
  batchPaidAmount: number | null = null;
  lang: string = 'en';
  accountCSN: string = "";
  accountId: string = "";
  // This method is used to initialize the class instance using router and route
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private api: ApiService,
    private sharedService: SharedService
  ) {
    this.accountCSN = this.sharedService.getCsnAccountId('csn'); //7093
    this.accountId = this.sharedService.getCsnAccountId('id'); //7093
    this.route?.data?.subscribe(data => {
      this.isStandalone = data['type'] == 'standalone' ? true : false;
    });
  }
  // This method is used to handle the on init lifecycle hook
  ngOnInit(): void {
    this.initializePaymentConfirmation();
  }

  private initializePaymentConfirmation(): void {
    this.paymentLoader = true;
    this.lang = (this.sharedService.getCurrentLang() || 'en').toLowerCase();
    this.route.queryParamMap.subscribe((params) => {
      this.type = params.get('type') || '';
      this.token = params.get('token') || '';
      // this.spTrn = params.get('sptrn') || '';
      const sptrnsNumber = params.get('sptrn') || '';
      const valueBeforeUnderscore = sptrnsNumber.split('_')[0];
      this.spTrn = valueBeforeUnderscore;

      this.srNumber = params.get('sr') || '';
      this.venueBookingId = String(params.get('venueBookingId') || '').trim();
      this.tryUpdateVenuePaymentStatus();
      const batchParam = params.get('bathId');
      if (batchParam) {
        try {
          this.batchData = JSON.parse(decodeURIComponent(batchParam));
          this.batchPaidAmount = this.getPaidAmountFromBatchData(this.batchData);
          console.log('Batch Data:', this.batchData);
          
          if( this.type && this.type === 'completed') {
              this.updatePaymentStatus(this.batchData);
          }
          this.srDetailFetchAttempts = 0;
          this.displayTotalAmount = this.batchPaidAmount ?? 0;
          this.getSrPaymentDetail();
        } catch (error) {
          this.paymentLoader = false;
          // console.error('Invalid batch data', error);
        }
      }
    });
  }

  updatePaymentStatus(batchData: any): void {
    let requestPayload = {
      "body": {
        "ProcessName": "DC Community Portal Online Transaction Wrapper WF",
        "DCMethod": "SUBMIT",
        "DCLoginName": this.sharedService.getUserProfile()['Login Name'] || '',
        "DCSPTxnId": this.spTrn || '',
        "DCDEGTxnId": batchData?.transactions?.[0]?.degTrn || '',
        "DCLanguage": this.lang === 'ar' ? 'ARA' : 'ENU',
      }
    }
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.ONLINE_PAYMENT_FLAG_UPDATE,
      requestPayload
    ).subscribe({
      next: () => {},
      error: () => {}
    });
  }

  private tryUpdateVenuePaymentStatus(): void {
    if (this.venuePaymentStatusUpdated || this.type !== 'completed' || !this.venueBookingId) {
      return;
    }

    this.api.updateVenueSrPaymentStatus(this.venueBookingId)
      .subscribe({
        next: () => {
          this.venuePaymentStatusUpdated = true;
        },
        error: () => {
          // Keep payment confirmation flow uninterrupted even if venue status update fails.
        }
      });
  }
  // This method is used to go to dashboard
  goToDashboard() {
    if (this.sharedService.getUser()) {
      this.router.navigate([RoutesPath.DASHBOARD]);
      return;
    } else {
      this.router.navigate([RoutesPath.PUBLIC.LOGIN]);
    }
  }

  suggestedServices: any = [{
    id: "coo",
    serviceName: "SUCCESS_PAGE.CERTIFICATE_OF_ORIGIN",
    path: `${RoutesPath.SERVICE}/${RoutesPath.COO.ISSUE}`

  }, {
    id: "ata",
    serviceName: "SUCCESS_PAGE.ATA_CARNET",
    path: `${RoutesPath.SERVICE}/${RoutesPath.ATA.CARNET}`
  }];

  showSuggestedService = false;
  paymentLoader: boolean = false;
  paymentList: any = [];
  grandTotal: any = 0;
  displayTotalAmount: number = 0;
  memberNameEnglish = '';
  memberNameArabic = '';
  isVenueBookingService: boolean = false;
  private srDetailFetchAttempts = 0;
  private readonly maxSrDetailFetchAttempts = 2;
  private readonly srDetailRetryDelayMs = 2000;

  getSrPaymentDetail() {
    //Standalone mode then retun without get sr detail
    if(this.isStandalone) {
      this.paymentLoader = false;
      return;
    }

    this.srDetailFetchAttempts++;

    if (!this.srNumber) {
      this.router.navigate([RoutesPath.DASHBOARD]);
      return;
    }

    let requestPayload = {
      "body": {
        "ProcessName": "DC Get Service Fees Line WF",
        "SRNumber": this.srNumber //"1-12688232998"//"1-12687654729,1-12687654829"
      }
    }
    this.api.post(
      ApiRoot.DCCICPIntegration,
      ApiEndPoints.GET_SR_SERVICE_FEES,
      requestPayload
    ).subscribe({
      // This method is used to handle the next callback using response
      next: (response: any) => {
        if (response['Error Code'] == null && response["SiebelMessage"]["DC Service Request Thin"]) {
          this.paymentList = Utils.checkIsArray(response["SiebelMessage"]["DC Service Request Thin"]);

          const firstRequest = this.paymentList?.[0];
          this.memberNameEnglish = firstRequest?.['DC Member Name (English)'] || this.companyName || '';
          this.memberNameArabic = firstRequest?.['DC Member Name (Arabic)'] || '';
          this.grandTotal = this.getGrandTotal(response);
          this.displayTotalAmount = this.grandTotal;
          this.isVenueBookingService = this.detectVenueBookingService(firstRequest);
          this.paymentLoader = false;

          this.getReceiptsByRefNumber();
        } else {
          this.paymentLoader = false;
        }
      }
    })
  }
  getGrandTotal(response: any): number {
    const serviceRequests =
      response?.SiebelMessage?.['DC Service Request Thin'] || [];

    return serviceRequests.reduce((srTotal: number, sr: any) => {
      const charges = sr['DC FS Charge'] || [];
      const chargeTotal = charges.reduce(
        (sum: number, c: any) => sum + (+c['Amount'] || 0),
        0
      );
      return srTotal + chargeTotal;
    }, 0);
  }

  // This method is used to get payments list
  payments: any = [];
  getReceiptsByRefNumber() {
    if (!this.accountCSN && !this.accountId) {
      return
    }
    this.payments = [];
    const payload = this.buildRequestPayload(10, 0, true);

    this.api.post(ApiRoot.DCCICPIntegration, ApiEndPoints.GET_ALL_PAYLIST, payload)
      .subscribe({
        next: (response: any) => {
          if (this.hasValidPaymentResponse(response)) {
            this.payments = Utils.checkIsArray(response?.SiebelMessage['FS Invoice']);
            this.updateDisplayedAmountForVenueBooking();
            this.retrySrPaymentDetailForPendingReceipt();
          }
        },
        error: () => {
        }
      })
  }

  private retrySrPaymentDetailForPendingReceipt(): void {
    const hasReceiptGenerationInProgress = Utils.checkIsArray(this.payments).some((payment: any) => {
      const receiptUrl = String(payment?.['DC eReceipt Download URL'] ?? '').trim().toLowerCase();
      return receiptUrl === 'document generation inprogress';
    });

    if (!hasReceiptGenerationInProgress || this.srDetailFetchAttempts >= this.maxSrDetailFetchAttempts) {
      return;
    }

    setTimeout(() => {
      this.getSrPaymentDetail();
    }, this.srDetailRetryDelayMs);
  }
  private buildRequestPayload(pageSize: number, startRowNum: number, newQuery: boolean): PaymentStatementRequest {
    this.request = new PaymentStatementRequest();
    const { body } = this.request;
    const invoice = body.IncomingHierarchy.ListOfDCInvoiceStatIO["FS Invoice"];

    body.IncomingHierarchy.MessageId = Utils.generateUniqueId();
    body.Language = this.lang === 'ar' ? 'ARA' : 'ENU';
    body.PageSize = pageSize.toString();
    body.StartRowNum = startRowNum;
    body.NewQuery = newQuery ? "true" : "false";
    body.NoDays = "180";

    invoice["DC Member Num"] = this.accountCSN ? this.accountCSN : this.accountId;
    invoice["DC SRType"] = '';
    invoice["DC SRSubType"] = '';
    invoice["Status"] = '';
    invoice['Payment Method'] = '';
    invoice['DC Parent Invoice Number'] = this.spTrn
    return this.request;
  }
  private hasValidPaymentResponse(response: any): boolean {
    const hasNoErrorCode = response?.["Error Code"] == null || response?.["Error Code"] === "";
    const hasNoErrorMessage = response?.["Error Message"] == null || response?.["Error Message"] === "";
    const hasInvoices = !!response?.SiebelMessage?.['FS Invoice'];
    return hasNoErrorCode && hasNoErrorMessage && hasInvoices;
  }

  private detectVenueBookingService(paymentItem: any): boolean {
    const type = String(paymentItem?.['SR Type'] ?? '').trim().toLowerCase();
    const subType = String(paymentItem?.['SR Sub Type'] ?? '').trim().toLowerCase();
    return type.includes('venue booking') || subType.includes('venue booking');
  }

  private get isVenueBookingContext(): boolean {
    return !!this.venueBookingId || this.isVenueBookingService;
  }

  private updateDisplayedAmountForVenueBooking(): void {
    if (!this.isVenueBookingContext) {
      this.displayTotalAmount = this.grandTotal;
      return;
    }
    if ((this.batchPaidAmount ?? 0) > 0) {
      this.displayTotalAmount = this.roundAmount(this.batchPaidAmount as number);
      return;
    }

    const paidAmount = Utils.checkIsArray(this.payments).reduce((sum: number, invoice: any) => {
      const amount = this.parseAmount(invoice?.['Total Paid'] ?? invoice?.['DC Credit'] ?? invoice?.['Total Amount']);
      return sum + amount;
    }, 0);

    this.displayTotalAmount = paidAmount > 0 ? this.roundAmount(paidAmount) : this.grandTotal;
  }

  private parseAmount(value: any): number {
    const normalized = String(value ?? '').replace(/,/g, '').trim();
    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : 0;
  }

  private roundAmount(value: number): number {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }

  private getPaidAmountFromBatchData(batchData: any): number | null {
    const transactions = Utils.checkIsArray(batchData?.transactions);
    if (!transactions.length) {
      return null;
    }

    const total = transactions.reduce((sum: number, txn: any) => {
      return sum + this.parseAmount(txn?.amount);
    }, 0);

    return total > 0 ? this.roundAmount(total) : null;
  }

  isValidReceiptURL() {
    if (this.payments?.length === 0) {
      return false;
    }
    let url = this.payments?.[0]?.['DC eReceipt Download URL'] || '';
    return Utils.checkIsValidURL(url);
  }

  downloadReceipt() {
    const receipts = Utils.checkIsArray(this.payments)
      .map((p: any) => p?.['DC eReceipt Download URL'])
      .filter((url: unknown): url is string => Utils.checkIsValidURL(url));

    if (!receipts.length) {
      return;
    }

    receipts.forEach((url, index) => {
      const link = document.createElement('a');
      link.href = url;
      link.download = Utils.extractFileNameFromUrl(url) || `receipt-${index + 1}`;
      link.rel = 'noopener';
      link.target = '_blank';
      link.click();
      link.remove();
    });
  }
}
